export default "__VITE_ASSET__806beac4__"